'use client';

import { useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { ButtonSize, ButtonVariant } from '@/components/ui/button/Button.types';
import { logger } from '@/lib/logger';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    logger.error('Unhandled error caught by global boundary', error, {
      feature: 'error-boundary',
      route: 'global',
      digest: error.digest,
    });
  }, [error]);

  return (
    <main
      id="main-content"
      role="alert"
      className="tw:flex tw:flex-col tw:items-center tw:justify-center tw:min-h-dvh tw:gap-base tw:p-huge"
    >
      <h1 className="tw:text-24 tw:font-bold tw:text-font" data-cy="global-error-title">
        Something went wrong
      </h1>
      <p
        className="tw:text-16 tw:text-gray-darker tw:text-center tw:max-w-md"
        data-cy="global-error-message"
      >
        An unexpected error occurred. Please try again.
      </p>
      <Button
        size={ButtonSize.large}
        variant={ButtonVariant.primary}
        onClick={reset}
        data-cy="global-error-retry-button"
      >
        Try again
      </Button>
    </main>
  );
}
